import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {TerminateTenancyForm, Buttons} from './components';

import {MODALS, fetchTerminationReasons} from 'ducks/tenancy';

import './styles.css';

class TerminateTenancyModal extends React.Component<any> {
  componentDidMount() {
    const {tenancyId} = this.props;
    const fetchTerminationReasonsExtraActions = this.props.storeDataExtraActions(
      data => ({terminationReasons: data})
    );
    this.props.fetchTerminationReasons(
      {tenancyId},
      fetchTerminationReasonsExtraActions
    );
  }

  triggerFormSubmit = () => {
    this.props.submit('terminateTenancy');
  };

  render() {
    const {form: {submitting}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="TerminateTenancyModal"
        type={Modal.EXTRA_SMALL}>
        <Modal.Header heading="Terminate License Early" />
        <Modal.Body>
          <TerminateTenancyForm tenancyId={this.props.tenancyId} />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('terminateTenancy')(state)
    }
  };
};

const mapDispatchToProps = {
  fetchTerminationReasons,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  MODALS.TERMINATE_TENANCY
)(TerminateTenancyModal) as React.ComponentType<any>);
